export const STAFF = '/staff/'
export const STAFF_ALL = `${STAFF}all`
export const STAFF_USERNAME = `${STAFF}username/`
